import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { UserService, AuthenticationService, HeaderService } from 'src/app/_services';
import { User } from 'src/app/_models';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-user-unsubscribe',
  templateUrl: './user-unsubscribe.component.html',
  styleUrls: ['./user-unsubscribe.component.css']
})
export class UserUnsubscribeComponent implements OnInit {

  public user: User;
  public submitted : boolean;
  public unsubscribeForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private users: UserService,
    private auth: AuthenticationService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private router: Router,
    private header: HeaderService

  ) { 
    this.users.editingUser.subscribe(user => this.user = user);
  }

  public get f () {
    return this.unsubscribeForm.controls;
  }

  ngOnInit() {
    this.submitted = false;
    
    this.unsubscribeForm = this.formBuilder.group({
      confirm: ['', Validators.requiredTrue],
    });

    this.header.scrollMain();
  }

  onSubmit(){
    this.submitted = true;

    if (this.unsubscribeForm.invalid){
      return ;
    }

    this.users.delete(this.user).subscribe();

  }


}
